/*
 * @Descripttion: 
 * @Author: luoyang
 * @Date: 2021-09-26 10:29:43
 * @LastEditors: luoyang
 * @LastEditTime: 2021-09-27 11:26:00
 */

export const baseRouter = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: '/404',
    component: () =>
      import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () =>
      import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '/home',
    component: () =>
      import('@/views/home/index'),
    hidden: true
  },
  {
    path: '/homeOld',
    component: () =>
      import('@/views/home/indexOld'),
    hidden: true
  },
  {
    path: '/companyprofile',
    component: () => import('@/views/about/companyprofile.vue'),
    hidden: true
  },
  {
    path: '/companyculture',
    component: () => import('@/views/about/companyculture.vue'),
    hidden: true
  },
  {
    path: '/honorqualification',
    component: () => import('@/views/about/honorqualification.vue'),
    hidden: true
  },
  {
    path: '/companyNews',
    component: () => import('@/views/news/companyNews.vue'),
    hidden: true
  },
  {
    path: '/companyDynamic',
    component: () => import('@/views/news/companyDynamic.vue'),
    hidden: true
  },
  {
    path: '/comNewsDetails',
    component: () => import('@/views/news/comNewsDetails.vue'),
    hidden: true
  },
  {
    path: '/contactus',
    component: () => import('@/views/about/contactus.vue'),
    hidden: true
  },
  {
    path: '/jobmarket',
    component: () => import('@/views/job/jobmarket.vue'),
    hidden: true
  },
  {
    path: '/solutionSafety',
    component: () => import('@/views/solution/solutionSafety.vue'),
    hidden: true
  },
  {
    path: '/solutionadmi',
    component: () => import('@/views/solution/solutionadmi.vue'),
    hidden: true
  },
  {
    path: '/projectassets',
    component: () => import('@/views/solution/projectassets.vue'),
    hidden: true
  },
  {
    path: '/comdedeauto',
    component: () => import('@/views/dedeauto/comdedeauto.vue'),
    hidden: true
  }
];

